import * as React from "react";
const SvgFunnel = props => <svg width="1em" height="1em" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.5 11h-3l-1-2h5l-1 2ZM10 8H4L3 6h8l-1 2ZM11.5 5h-9l-1-2h11l-1 2ZM13 2H1L0 0h14l-1 2Z" fill="#677489" /></svg>;
export default SvgFunnel;